// ═══════════════════════════════════════════════════════════════════════════════
// HTML armado a mano (ventanas de impresión, reportes, proformas).
//
// Esas ventanas se abren con window.open('') o con un blob: y comparten el origen
// del portal: un <script> metido en un nombre de paciente correría con la sesión
// de quien abre la ventana (Parte B de la auditoría, 1-nov-2026). Por eso TODO
// dato que venga de la base, de un QR o de un formulario pasa por esc() antes de
// entrar al HTML, y por jsonEnScript() si va dentro de un <script>.
// ═══════════════════════════════════════════════════════════════════════════════

/** Texto seguro para meter entre etiquetas o en un atributo con comillas. */
export function esc(v) {
  return String(v ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/**
 * JSON listo para pegar dentro de un <script>: ningún valor puede cerrar la
 * etiqueta (</script>), abrir un comentario HTML ni cortar la línea.
 */
export function jsonEnScript(valor) {
  return JSON.stringify(valor)
    .replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
